<template>
    <div>
        <SOFilterBase v-if="isFilterOpen" @back="toggleFilter(false)" @do-filter="doFilter" @reset-filter="resetFilter">
            <template v-slot:filters>
                <div>
                    <SOFilterPeriode
                        :id="`filter-periode`"
                        :title="`Periode`"
                        :periode-transaksi="false"
                        :option-data="periode.data"
                        v-model="periode.selected"
                        :filter-global-key="periode.filterGlobalKey"
                        :keterangan="periode.keterangan"
                    />
                    <SOFilterStatusGaji
                        ref="filterStatusGaji"
                        :id="'filter-status-invoice'"
                        :title="`Status Invoice`"
                        :data-options="getFilterOptions.statusInvoice"
                    />
                    <SOFilterStatusKonfirmasi
                        ref="filterStatusBayar"
                        :id="'filter-status-bayar'"
                        :title="`Status Bayar`"
                        :data-options="getFilterOptions.statusBayar"
                    />
                    <SOFilterJenisPembayaran
                        :id="'filter-jenis-pembayaran'"
                        :data-options="getFilterOptions.jenisPembayaran"
                        :use-akun-edc="false"
                        :use-akun-debit="false"
                    />
                    <SOFilterOutlet :id="'filter-outlet'" title="Transaksi di Outlet" />
                    <SOFilterKonsumen :id="'filter-konsumen'" title="Konsumen" />
                    <SOFilterKaryawan
                        use-all-karyawan
                        :id="'filter-karyawan'"
                        :title="`Hanya nota yang dibuat oleh`"
                        :label="`Nama Karyawan`"
                    />
                </div>
            </template>
        </SOFilterBase>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { moduleName } from "../store/state";
import filterOptions from "../static/filterOptions";

import SOFilterBase from "@/so-components/global/filter/base/SOFilterBase.vue";

import SOFilterPeriode from "@/so-components/global/filter/type/SOFilterPeriode";
import SOFilterStatusGaji from "@/so-components/global/filter/type/SOFilterStatusGaji";
import SOFilterStatusKonfirmasi from "@/so-components/global/filter/type/SOFilterStatusKonfirmasi";
import SOFilterOutlet from "@/so-components/global/filter/type/SOFilterOutlet";
import SOFilterKaryawan from "@/so-components/global/filter/type/SOFilterKaryawan";
import SOFilterKonsumen from "@/so-components/global/filter/type/SOFilterKonsumen";
import SOFilterJenisPembayaran from "@/so-components/global/filter/type/SOFilterJenisPembayaran";

export default {
    name: "FilterInvoice",
    props: {
        loadInvoice: {
            type: Function,
            required: true,
        },
    },
    components: {
        SOFilterBase,
        SOFilterPeriode,
        SOFilterStatusGaji,
        SOFilterStatusKonfirmasi,
        SOFilterOutlet,
        SOFilterKaryawan,
        SOFilterKonsumen,
        SOFilterJenisPembayaran,
    },
    data() {
        return {
            periode: {
                data: [
                    { id: "created_at", text: "tanggal pembuatan" },
                    { id: "tanggal_jatuh_tempo", text: "tanggal jatuh tempo" },
                ],
                selected: "created_at",
                filterGlobalKey: "periode_state",
                keterangan: "",
            },
        };
    },
    computed: {
        ...mapGetters(moduleName, {
            isFilter: "isFilter",
        }),
        ...mapGetters("filterGlobalModule", {
            getFilterItem: "getFilterItem",
        }),
        isFilterOpen() {
            return this.isFilter;
        },
        getFilterOptions() {
            return filterOptions;
        },
        getPeriodeState() {
            return this.getFilterItem?.periode_state;
        }
    },
    methods: {
        ...mapActions({
            setFilter: `${moduleName}/setFilter`,
            resetPage: `${moduleName}/resetPage`,
            resetList: `${moduleName}/resetList`,
        }),
        toggleFilter(val) {
            this.setFilter(val);
        },
        async doFilter() {
            await this.resetPagination();
            await this.resetDataList();
            await this.toggleFilter(false);
            this.loadInvoice();
        },
        resetDataList() {
            this.resetList({ target: "invoice" });
        },
        resetPagination() {
            this.resetPage({ target: "invoice" });
        },
        async resetFilter() {
            await this.$store.commit("filterGlobalModule/resetFilterItem");
        },
    },
};
</script>
